import { Entity } from "../helpers/Entity"

export type AddonAttributesDto = {
    id: string,
    nameEnglish: string,
    nameFrench: string,
    descriptionEnglish: string,
    descriptionFrench: string,
    features: string[],
    price: string,
    document_limit: string,
    bankTransferFeePercentage: string,
    bankTransferFeeAmount: string,
    bankTransferFeeCap: string,
    creditCardAmount: string,
    creditCardPercentage: string,
    maxNumberOfUsers: string,
    intervalType: string,
    modifiedQMAttribute: string,
    displayDescriptionFooter:boolean,
}

export type AddonDto = {
    attributes: AddonAttributesDto
    id: string
    type: string
}

export default class Addon implements Entity {
    dto: AddonDto
    constructor(dto: AddonDto) {
        this.dto = dto
    }

    getAddonName(language: string): string {
        if (language.includes("fr")) {
            return this.dto.attributes.nameFrench
        } else {
            return this.dto.attributes.nameEnglish
        }
    }

    getAddDisplayDescriptionFooter(): boolean {
        return this.dto.attributes.displayDescriptionFooter
    }

    getAddOnDescription(language: string): string {
        if (language.includes("fr")) {
            return this.dto.attributes.descriptionFrench
        } else {
            return this.dto.attributes.descriptionEnglish
        }
    }

    getAttributes(): AddonAttributesDto {
        return this.dto.attributes
    }

    getPrice(): string {
        return this.dto.attributes.price
    }

    getDocumentLimit(): string {
        return this.dto.attributes.document_limit
    }

    getBankTransferFeePercentage(): string {
        return this.dto.attributes.bankTransferFeePercentage
    }

    getBankTransferFeeAmount(): string {
        return this.dto.attributes.bankTransferFeeAmount
    }

    getBankTransferFeeCap(): string {
        return this.dto.attributes.bankTransferFeeCap
    }

    getCreditCardAmount(): string {
        return this.dto.attributes.creditCardAmount
    }

    getCreditCardPercentage(): string {
        return this.dto.attributes.creditCardPercentage
    }

    getMaxNumberOfUsers(): string {
        return this.dto.attributes.maxNumberOfUsers
    }

    getIntervalType(): string {
        return this.dto.attributes.intervalType
    }

    isAddonWithQuantity(): string {
        return this.dto.attributes.modifiedQMAttribute
    }

    hasFeature(module: string): boolean {
        return this.dto.attributes.features && this.dto.attributes.features.includes(module)
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "addons"
    }

    getId(): string {
        return this.dto.id
    }
}


// WEBPACK FOOTER //
// ./src/state/billing/Addon.ts